module.exports = __webpack_public_path__ + "img/demand-title.5365f9bc.png";